import type { ContentPage } from "@/lib/content/types";

export const socialMedia: ContentPage = {
  slug: "omni-channels/social-media",
  template: "hrmsFeature",
  seo: {
    title: "Social CRM - Manage Social Messages & Leads | GetBiz CRM",
    description:
      "Capture social messages, comments and leads into GetBiz CRM. Reply to Facebook, Instagram and more from one inbox with full context on every contact.",
    keywords: [
      "social CRM",
      "social media CRM",
      "social inbox",
      "social lead capture",
      "social media management CRM",
      "social customer service",
    ],
    ogImage: "/assets/data/seoimages/social-media.webp",
  },
  leaf: {
    hero: {
      caption: "Social Media",
      title: "Turn Social Conversations Into CRM Records",
      description:
        "Bring messages, comments and mentions from your social channels into GetBiz CRM, so leads are captured and every reply carries full customer context.",
      h1: "caption",
    },
    split: {
      title: "Social, Connected to Your Pipeline",
      bullets: [
        { title: "Unified Social Inbox", description: "Reply to every network from one place." },
        { title: "Lead Capture", description: "Turn DMs and comments into CRM leads." },
        { title: "Full Context", description: "See history before you reply." },
        { title: "Team Routing", description: "Assign social conversations to the right rep." },
      ],
      image: "/assets/images/img/product/crm/social-media-lead-image.webp",
      imageAlt: "GetBiz CRM social media",
    },
    cardsHeading: { title: "More Omni Channels", description: "Social Media works with the rest of GetBiz CRM omni-channel." },
    cards: [
      { title: "WhatsApp", href: "/crm-software/omni-channels/whatsapp/", description: "Continue chats on WhatsApp.", image: "/assets/images/img/product/crm/whatsapp.webp", imageAlt: "CRM WhatsApp" },
      { title: "Live Chat", href: "/crm-software/omni-channels/live-chat/", description: "Catch website visitors in real time.", image: "/assets/images/img/product/crm/live-chat.webp", imageAlt: "CRM live chat" },
      { title: "Email", href: "/crm-software/omni-channels/email/", description: "Follow up by tracked email.", image: "/assets/images/img/product/crm/email.webp", imageAlt: "CRM email" },
      { title: "Webforms", href: "/crm-software/omni-channels/webforms/", description: "Capture social traffic with lead forms.", image: "/assets/images/img/product/crm/webform.webp", imageAlt: "CRM webforms" },
    ],
    testimonials: { title: "Never miss a social lead", description: "See why teams manage social in GetBiz CRM." },
    bookDemoTitle: "Bring social into your CRM.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "social-crm-guide, social-selling-guide",
    metaKey: "social-media",
  },
  sections: [],
};
